import styles from './page-wrapper.module.scss';

export const PageWrapper = ({children}) => (
  <div className={styles.wrapper}>{children}</div>
);
